export default function numInputInit() {
  const numInputSel = '.js-num-input'
  const inputDefaultMin = -Infinity
  const inputDefaultMax = Infinity

  function disableBtns(value, min, max, minusBtn, plusBtn) {
    /* eslint-disable no-param-reassign */
    minusBtn.disabled = false
    plusBtn.disabled = false

    if (value === min) {
      minusBtn.disabled = true
    }
    if (value === max) {
      plusBtn.disabled = true
    }
    /* eslint-enable no-param-reassign */
  }

  function triggerEvent(eventName, target) {
    const event = new Event(eventName, { bubbles: true })
    target.dispatchEvent(event)
  }

  // Catches value changes via JS
  // https://stackoverflow.com/a/48528450/8313588
  function customInputSetter(){
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')
    const originalSet = descriptor.set

    descriptor.set = function set(...rest) {
      originalSet.apply(this, rest)
      triggerEvent('changedFromJS', this)
    }

    Object.defineProperty(HTMLInputElement.prototype, 'value', descriptor)
  }

  customInputSetter()

  function initNewNumInput(elem) {
    const input = elem.querySelector('input')
    const minusBtn = input.previousElementSibling
    const plusBtn = input.nextElementSibling
    const value = +input.value
    const min = +input.min || inputDefaultMin
    const max = +input.max || inputDefaultMax

    disableBtns(value, min, max, minusBtn, plusBtn)
  }

  /* eslint-disable no-restricted-syntax, no-continue */
  function observeMutations() {
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for(const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue

          if (node.matches(numInputSel)) {
            initNewNumInput(node)
          }

          for (const elem of node.querySelectorAll(numInputSel)) {
            initNewNumInput(elem)
          }
        }
      }
    })
    /* eslint-enable no-restricted-syntax, no-continue */

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  observeMutations()

  function onClickHandler(e) {
    if (e.target.closest(numInputSel) && e.target.tagName === 'BUTTON') {
      const btn = e.target
      const op = btn.nextElementSibling ? 'minus' : 'plus'
      // const anotherBtn = op === 'minus' ?
      //   btn.nextElementSibling.nextElementSibling :
      //   btn.previousElementSibling.previousElementSibling
      const input = btn.parentElement.querySelector('input')
      const value = +input.value
      const min = +input.min || inputDefaultMin
      const max = +input.max || inputDefaultMax

      if (op === 'plus') {
        input.value = Math.min(value + 1, max)
      } else {
        input.value = Math.max(value - 1, min)
      }

      triggerEvent('change', input)

      // This is no longer needed, since there is a custom event that catches input changes made via JS
      // disableBtns(
      //   +input.value,
      //   min,
      //   max,
      //   op === 'minus' ? btn : anotherBtn,
      //   op === 'plus' ? anotherBtn : btn
      // )
    }
  }

  function onInputHandler(e) {
    if (e.target.closest(numInputSel) && e.target.tagName === 'INPUT') {
      const input = e.target
      const minusBtn = input.previousElementSibling
      const plusBtn = input.nextElementSibling
      const value = +input.value
      const min = +input.min || inputDefaultMin
      const max = +input.max || inputDefaultMax

      if (value < min) {
        input.value = Math.max(min, value)
      } else if (value > max) {
        input.value = Math.min(max, value)
      } else {
        input.value = value
      }

      disableBtns(+input.value, min, max, minusBtn, plusBtn)
    }
  }

  function onChangeHandler(e) {
    if (e.target.closest(numInputSel) && e.target.tagName === 'INPUT') {
      const input = e.target
      const minusBtn = input.previousElementSibling
      const plusBtn = input.nextElementSibling
      const min = +input.min || inputDefaultMin
      const max = +input.max || inputDefaultMax

      disableBtns(+input.value, min, max, minusBtn, plusBtn)
    }
  }

  document.addEventListener('click', onClickHandler)
  document.addEventListener('input', onInputHandler, true)
  document.addEventListener('changedFromJS', onChangeHandler, true)
}